import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";
import {GatewayPendingConfigPayloadDTO} from "./GatewayPendingConfigPayloadDTO";

class O {
  payload!: GatewayPendingConfigPayloadDTO;
  fromDraft!: boolean;
}

class I {
  gatewayId!: number;
}

export class ReadGatewayPendingConfigFallbackCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(GatewayPendingConfigOPEEnum.ReadGatewayPendingConfigFallback);
    this.i = new I();
    this.o = new O();
  }
}
